import React from 'react';
import { Link } from 'react-router-dom';
import dateHelper from '../../util/dateFormatter'
import numberHelper from '../../util/numberFormatter'

const CoinTransactionList = props => {
  if (!props.transactions) {
    return (
      <div className='broad'>Loading...</div>
    );
  }

  if (props.transactions.length === 0) {
    return (
      <div className='empty'>
        No transactions...
      </div>
    );
  }

  return (
    <div>
      <table className="dataTable">
        <thead>
          <tr>
            <th>key</th>
            {/* <th>owner</th> */}
            <th>symbol</th>
            <th>user key</th>
            <th>created</th>
            <th>amount</th>
          </tr>
        </thead>
        <tbody>
          {
            props.transactions.map(transaction => {
              return (
                <tr key={transaction.key}>
                  <td className="keyfield"><Link to={`/coins/transactions/${transaction.key}`}>{transaction.key}</Link></td>
                  {/* <td>{transaction.owner}</td> */}
                  <td>{transaction.symbol}</td>
                  <td className="keyfield">{transaction.account ?

                    (
                      transaction.account.user_key.toUpperCase() === 'MASTER' ?
                        transaction.symbol + ' MASTER'
                        : <Link to={`/users/${transaction.account.user_key}`}>{transaction.account.user_key}</Link>)
                    : transaction.owner}</td>
                  <td>{dateHelper.Formatter.toLocalString(transaction.created)}</td>
                  <td>{numberHelper.Formatter.toDecimal(transaction.amount)}</td>
                </tr>
              )
            })
          }
        </tbody>
      </table>
    </div>
  );
};

export default CoinTransactionList;



// WEBPACK FOOTER //
// ./src/components/widgets/CoinTransactionList.js